@file:OptIn(InternalResourceApi::class)

package hotpla.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/hotpla.shared.generated.resources/"

@delegate:ResourceContentHash(1_747_825_580)
internal val Res.font.be_vietnam_pro_regular: FontResource by lazy {
      FontResource("font:be_vietnam_pro_regular", setOf(
        ResourceItem(setOf(), "${MD}font/be_vietnam_pro_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_143_772_571)
internal val Res.font.be_vietnam_pro_semibold: FontResource by lazy {
      FontResource("font:be_vietnam_pro_semibold", setOf(
        ResourceItem(setOf(), "${MD}font/be_vietnam_pro_semibold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-57_045_029)
internal val Res.font.literata_italic_variable: FontResource by lazy {
      FontResource("font:literata_italic_variable", setOf(
        ResourceItem(setOf(), "${MD}font/literata_italic_variable.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-978_619_194)
internal val Res.font.literata_variable: FontResource by lazy {
      FontResource("font:literata_variable", setOf(
        ResourceItem(setOf(), "${MD}font/literata_variable.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("be_vietnam_pro_regular", Res.font.be_vietnam_pro_regular)
  map.put("be_vietnam_pro_semibold", Res.font.be_vietnam_pro_semibold)
  map.put("literata_italic_variable", Res.font.literata_italic_variable)
  map.put("literata_variable", Res.font.literata_variable)
}
